export class CompanyInfo {
  countryName: string;
  yearIncorporated?: number;
  idNumber: string;
  type: string;
  status: string;
  independenceIndicator: string;
  financialType: string;
  webSite: string;
  address: string;
  phone: string;
  tickerSymbol: string;
  cik: string;
  stockExchange: string;
  segmentedFinancials: boolean;
}
